import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import Link from 'next/link'
import Image from 'next/image'
import { NewsCardType } from '@interfaces/aboutUs'
import { useElementVisible } from '@hooks/useElementVisible'
import { EVENTS } from '@configs/events.config'
import { TENANT_TYPE } from '@components/Ackodrive/common/constants'
import styles from './NewsSection.module.scss'

export const NewsCard = ({ news }: NewsCardType) => {
  const newsCardSection = useElementVisible({ threshold: 0.1 })
  const handleClick = async (url: string) =>
    await trackEvent(EVENTS[TENANT_TYPE.ABOUTUS].engage.eventname, {
      ...EVENTS[TENANT_TYPE.ABOUTUS].engage.eventProps,
      redirection_url: url,
    })

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <Link href={news.newsUrl} target="_blank" onClick={() => handleClick(news.newsUrl)}>
      <div
        ref={newsCardSection.ref}
        className={`${styles.newsCard} ${newsCardSection.isVisible ? styles.visible : ''}`}>
        <div className={styles.newsDetails}>
          <img alt="news-logo" src={news.newsLogoUrl} />
          <p className={styles.newsDate}>{news.newsDate}</p>
        </div>
        <div className={styles.newsImageContainer}>
          <Image alt="news-image" src={news.newsImageUrl} width={410} height={280} />
        </div>
        <div className={styles.newsContentContainer}>
          <div>
            <p className={styles.newsHeading}>{news.newsHeading}</p>
            <p className={styles.newsContent}>{news.newsContent}</p>
          </div>
          <div className={styles.icon} />
        </div>
      </div>
    </Link>
  )
}
